exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".clickable-root-3EF {\n    align-items: center;\n    cursor: pointer;\n    display: inline-flex;\n    justify-content: center;\n    line-height: 1;\n    pointer-events: auto;\n    text-align: center;\n    white-space: nowrap;\n}\n", ""]);

// Exports
exports.locals = {
	"root": "clickable-root-3EF"
};